import PropTypes from "prop-types";
import { AnchorImpl } from "./anchor.styles.es.js";
const propTypes = {
  appearance: PropTypes.oneOf(["default", "plain"])
};
const defaultProps = {
  appearance: "default"
};
AnchorImpl.propTypes = propTypes;
AnchorImpl.defaultProps = defaultProps;
export {
  AnchorImpl as Anchor
};
